/**
 * Media list-response schema — SCRUM-147 / DS-011-6, extended in SCRUM-149.
 *
 * HTTP-boundary Zod schema describing the GET media list response shape
 * (`GET /organizations/:slug/properties/:propertyId/media`). The controller
 * serializes the GetPropertyMediaQuery result into `{ media: [...], readiness: {...} }`.
 *
 * Per item (mirrors PropertyMediaListItem in get-property-media.query.ts):
 *   - kind: 'photo' | 'video-url' | 'matterport-url'
 *   - status: always 'active' (the query filters to active)
 *   - url: signed download URL for photos; null for external-url rows
 *   - externalUrl: passthrough for external-url rows; null for photos
 *
 * readiness (SCRUM-149): derived signals computed in-query over the active row set.
 *   - activePhotoCount: int >= 0 — active photos only (excludes external-URL rows)
 *   - hasMainPhoto: boolean — true iff at least one active photo has isMain===true
 *   - photosWithoutDescriptionCount: int >= 0 — active photos where description===null
 */
import { z } from 'zod';
export const MEDIA_KINDS = ['photo', 'video-url', 'matterport-url'];
export const MEDIA_STATUSES = [
    'pending-upload',
    'active',
    'soft-deleted',
];
export const mediaListItemSchema = z.object({
    mediaId: z.string(),
    kind: z.enum(MEDIA_KINDS),
    status: z.enum(MEDIA_STATUSES),
    displayOrder: z.number().int(),
    isMain: z.boolean(),
    description: z.string().nullable(),
    url: z.string().nullable(),
    externalUrl: z.string().nullable(),
});
/**
 * Derived readiness signals for a property's media library (SCRUM-149).
 * Counts are non-negative integers; zero is valid (boundary accepted).
 * Negatives, decimals, strings, and null are all rejected (adversarial).
 */
export const mediaReadinessSchema = z.object({
    activePhotoCount: z.number().int().nonnegative(),
    hasMainPhoto: z.boolean(),
    photosWithoutDescriptionCount: z.number().int().nonnegative(),
});
export const mediaListResponseSchema = z.object({
    media: z.array(mediaListItemSchema),
    readiness: mediaReadinessSchema,
});
//# sourceMappingURL=media-list-response.schema.js.map